import useTranslation from 'Hooks/useTranslation';
import { useMemo } from 'react';
import { CoursesReportIcon, EmployeesReportIcon } from '../components/icons';
import type { ReportButtonConfig } from '../components/ReportsButtonGroup/ReportsButtonGroup';

/**
 * Single source of truth for the tabs of the Reports section. Permission-gated:
 * pages where the user lacks permission disappear from the tab strip.
 *
 * Mirror this hook from any "current" reports page so adding a new tab only
 * requires editing one file.
 */
export default function useReportButtons(): ReportButtonConfig[] {
  const { t2 } = useTranslation('employees_reports');

  return useMemo(
    () => [
      {
        icon: <EmployeesReportIcon />,
        tooltip: t2('employees_report_tooltip'),
        route: '/reporte/empleados',
      },
      {
        icon: <CoursesReportIcon />,
        tooltip: t2('courses_report_tooltip'),
        route: '/reporte/cursos',
      },
    ],
    [t2]
  );
}
